var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyActionBar, ReactElementFactory, SurveyElementBase } from "survey-react-ui";
import { SurveySimulator } from "./SurveySimulator";
import { SurveyResults } from "../Results";
import { SurfacePlaceholder } from "../components/SurfacePlaceholder";
var TabThemeSurveyComponent = /** @class */ (function (_super) {
    __extends(TabThemeSurveyComponent, _super);
    function TabThemeSurveyComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TabThemeSurveyComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    TabThemeSurveyComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabThemeSurveyComponent.prototype.renderPlaceholder = function () {
        return React.createElement(SurfacePlaceholder, { name: "theme", placeholderTitleText: this.model.placeholderTitleText, placeholderDescriptionText: this.model.placeholderDescriptionText });
    };
    TabThemeSurveyComponent.prototype.renderSimulator = function () {
        return (React.createElement("div", { className: "svc-plugin-tab__content" },
            React.createElement(SurveySimulator, { model: this.model.simulator }),
            this.model.showResults ? React.createElement(SurveyResults, { survey: this.model.simulator.survey }) : null));
    };
    TabThemeSurveyComponent.prototype.renderElement = function () {
        var tabContentClassName = "svc-creator-tab__content svc-test-tab__content" + (this.model.isPageToolbarVisible ? " svc-creator-tab__content--with-toolbar" : "");
        return (React.createElement("div", { className: tabContentClassName },
            this.model.simulator.survey.isEmpty ? this.renderPlaceholder() : this.renderSimulator(),
            this.getBottomToolbar()));
    };
    TabThemeSurveyComponent.prototype.getBottomToolbar = function () {
        if (this.model.isPageToolbarVisible) {
            return (React.createElement("div", { className: "svc-test-tab__content-actions" },
                React.createElement(SurveyActionBar, { model: this.model.pages })));
        }
        else {
            return null;
        }
    };
    return TabThemeSurveyComponent;
}(SurveyElementBase));
export { TabThemeSurveyComponent };
ReactElementFactory.Instance.registerElement("svc-tab-theme", function (props) {
    return React.createElement(TabThemeSurveyComponent, props);
});
